
/**
 * Learning Unit types
 */
export enum LearningUnitType {
    ActionLearning = "Action Learning",
    Assessment = "Assessment",
    Audio = "Audio/Podcast",
    Book = "Book",
    Blog = "Blog",
    Coaching = "Coaching",
    Conference = "Conference",
    Course = "Training Course/Workshop",
    ELearning = "eLearning",
    OnGoingProgramme = "Development Programme",
    Shoadowing = "Shadowing",
    Video = "Video",
    Other = "Other"
}

